<div *ngIf="screen === 'desktop'" class="main-content"></div>
<div class="main-content">
  <div class="header">
    <h1>
      <i class="fa fa-user-circle"></i> {{ "dashboard.hello" | translate }},
      {{ username }}!
    </h1>
  </div>

  <div class="dashboard-cards">
    <div class="password-card">
      <h2>{{ "dashboard.title" | translate }}</h2>
      <p>{{ "dashboard.explanatory" | translate }}</p>

      <button
        class="btn-password"
        *ngIf="!userPassFormVisible && !isLoadingUserPassForm"
        (click)="showUserPassForm()"
      >
        <span class="material-icons">lock_reset</span>
      </button>

      <div *ngIf="isLoadingUserPassForm" class="spinner-container">
        <span class="spinner"></span>
      </div>

      <user-pass
        *ngIf="userPassFormVisible"
        [selectedUsername]="username"
        (cancel)="cancelPasswordChange()"
      ></user-pass>
    </div>
    <versions></versions>
 <!--<debug-panel [screenType]="screen"></debug-panel>-->


  </div>
</div>
